import FormSection from './FormSection.jsx';
import { ArrowRightIcon } from '@heroicons/react/24/outline/index.js';
import React from 'react';
import { FormPart, part, sectionAttributes } from '~/lib/FormCssApi';

const FormViewSections = ({
    sections,
    submit,
    formData,
    setFormData,
    showNextSection,
    submitError,
    setSubmitError,
    isSubmitting,
    hasPaymentStep,
    submitIsNext,
    isGated,
    hasEvents,
    visibleSections,
    styles,
}) => {
    function sectionState(sectionId) {
        const index = visibleSections.indexOf(sectionId);

        if (index < 0) {
            return 'hidden';
        }

        return index === visibleSections.length - 1 ? 'current' : 'visible';
    }

    // noValidate because native constraint validation runs before the submit
    //  event, so a field the browser considers bad (ex. a half entered date)
    //  would block us from ever reporting our own, more useful, error
    return (
        <form
            onSubmit={submit}
            {...part(FormPart.FORM)}
            className="form-section-container"
            noValidate
        >
            {sections.map((sectionData, sectionIndex) => (
                <div
                    key={sectionData.section.id}
                    data-sectionid={sectionData.section.id}
                    {...sectionAttributes({
                        sectionId: sectionData.section.id,
                        index: sectionIndex + 1,
                        state: sectionState(sectionData.section.id),
                    })}
                    className={
                        'form-section ' +
                        (visibleSections.indexOf(sectionData.section.id) > -1
                            ? 'form-section-visible'
                            : 'form-section-hidden') +
                        (visibleSections.indexOf(sectionData.section.id) ===
                        visibleSections.length - 1
                            ? ' form-section-current'
                            : '')
                    }
                >
                    <FormSection
                        section={sectionData.section}
                        questions={sectionData.questions}
                        isVisible={visibleSections.indexOf(sectionData.section.id) > -1}
                        formData={formData}
                        setFormData={(id, value) => {
                            setFormData(old => {
                                let newValue = value;
                                if (typeof value === 'function') {
                                    newValue = value(old[id]);
                                }

                                return {
                                    ...old,
                                    [id]: newValue,
                                };
                            });
                        }}
                    />
                </div>
            ))}
            {!styles?.hideSubmit && !isGated && (
                <div className="">
                    {!submitIsNext && (
                        <button
                            {...part(FormPart.NEXT)}
                            className="flex items-center justify-between form-button"
                            type="button"
                            onClick={showNextSection}
                        >
                            <span className="">Next</span>
                            <ArrowRightIcon className="w-4 h-4 ml-2" />
                        </button>
                    )}
                    {submitIsNext && (
                        <>
                            {!!submitError && (
                                <div
                                    {...part(FormPart.FORM_ERROR)}
                                    className="text-red-600 mb-2 text-base font-medium"
                                >
                                    {submitError}
                                </div>
                            )}
                            <button
                                {...part(FormPart.SUBMIT)}
                                className="min-w-32 form-button"
                                type="submit"
                            >
                                {isSubmitting
                                    ? 'Submitting...'
                                    : hasPaymentStep
                                      ? 'Pay'
                                      : hasEvents
                                        ? 'Confirm'
                                        : 'Submit'}
                            </button>
                        </>
                    )}
                </div>
            )}
        </form>
    );
};

export default FormViewSections;
